import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {useEffect, useState} from 'react';

import {useHideSearchBarStore} from 'presentation/modules/booking/shared/store/useHideSearchBarStore';
import {useWellBornEligibility} from 'presentation/modules/booking/shared/hooks/useWellBornEligibility';
import {WellBornEndpoints} from 'presentation/modules/booking/shared/constants/beBornWell';

const {beBornWellInfos, beBornWellRegisteredCard, beBornWellInAcquisition, carryPregnancyWellCard} =
	translations['pt-br'].privateFlow.bookingFlow.beBornWellFlow;

export function useBeBornWellCard() {
	const {isMobile} = useMediaQueries();
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const setHideSearchBarState = useHideSearchBarStore(state => state.setHideSearchBar);
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const {eligibilityData} = useWellBornEligibility();
	const isWellBorn = eligibilityData?.cidadePrograma === WellBornEndpoints.WELL_BORN;
	const isInAcquisition = eligibilityData?.usuarioEmCaptacao;
	const isWellBornAcquisition = isWellBorn && isInAcquisition;

	useEffect(() => {
		setHideSearchBarState(true);
	}, []);

	const phoneNumbers = [beBornWellInfos.telephoneNumber];
	const hasPhoneNumbers = !!phoneNumbers;
	const isPhoneNumberMenuOpen = Boolean(anchorEl);

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isMobile) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorEl(event.currentTarget);
	};

	const isPhoneMenuEnabled = !isMobile && hasPhoneNumbers;
	const isPhoneDrawerEnabled = isMobile && hasPhoneNumbers;

	const getCardContent = () => {
		if (eligibilityData?.cidadePrograma === WellBornEndpoints.WELL_BORN) {
			if (eligibilityData?.usuarioNoPrograma) {
				return beBornWellRegisteredCard;
			}
			if (eligibilityData?.usuarioEmCaptacao) {
				return beBornWellInAcquisition;
			}
		}

		if (eligibilityData?.cidadePrograma === WellBornEndpoints.CARRY_PREGNANCY_WELL) {
			return carryPregnancyWellCard;
		}

		return beBornWellInAcquisition;
	};

	const cardContent = getCardContent();

	return {
		isMobile,
		openPhoneDrawerState,
		setOpenPhoneDrawerState,
		anchorEl,
		setAnchorEl,
		isWellBorn,
		handleOpenPhoneMenu,
		isPhoneMenuEnabled,
		isPhoneDrawerEnabled,
		phoneNumbers,
		isPhoneNumberMenuOpen,
		cardContent,
		isWellBornAcquisition,
		callChatRoom,
		callChatRoomIsLoading,
	};
}
